import { projects } from "../../data/projects";

import ProjectCard from "./ProjectCard";

function Projects() {
  return (
    <>
      <section className="section portfolio" id="portfolio">
        <div className="container">
          <p className="section-subtitle">Portfolio</p>

          <h2 className="h2 section-title">My Amazing Works</h2>

          <p className="section-text">
            Dliquip ex ea commo do conse namber onequa ute irure dolor in
            reprehen derit in voluptate
          </p>

          <ul className="portfolio-list">
            {projects.map((project) => {
              return <ProjectCard key={project.title} project={project} />;
            })}
          </ul>
        </div>
      </section>
    </>
  );
}

export default Projects;
